<template>
  <v-dialog v-model="showNewDialog" max-width="800px" persistent scrollable>
    <v-form ref="form" @submit.prevent="submit" v-model="valid">
      <v-card class="window-card px-4 py-5">
        <v-overlay :value="overlay">
          <v-card class="d-flex flex-column justify-center white px-10">
            <div class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="success"></v-progress-circular>
            </div>
            <div class="d-flex justify-center pb-5 green--text text-bold">
              {{ uploadProgress }}
            </div>
          </v-card>
        </v-overlay>

        <v-card-title>
          <span class="md-title" style="color: #67ad5b">新建设备模型</span>
        </v-card-title>
        <v-card-text style="padding-top: 0">
          <v-banner shaped>
            <h5>您是否已经有建好的设备模型？</h5>

            <template v-slot:actions>
              <v-switch v-model="form.mod_exist"></v-switch>
            </template>
          </v-banner>

          <div class="text-success" v-if="form.mod_exist">关于模型的标准,请参考 <a>《设备模型资源的标准》</a></div>
          <div class="text-success" v-else>关于模型的标准,请参考 <a>《设备模型需求的标准》</a></div>
          <v-text-field v-model="form.mod_name" label="模型名称 *" color="#4caf50"
            :rules="[(v) => !!v || '模型名称不能为空']"></v-text-field>
          <v-select v-model="form.model_category" :items="categoryList" item-text="name" color="#4caf50" item-value="type"
            label="类型 *" no-data-text="暂无数据" :rules="[(v) => !!v || '类型不能为空']"></v-select>
          <v-select v-model="form.mod_major" :items="majorListData" item-text="name" color="#4caf50" item-value="code"
            label="分类 *" no-data-text="暂无数据" :rules="[(v) => !!v || '专业分类不能为空']"></v-select>

          <v-textarea v-model="form.mod_description" label="描述" color="#4caf50"></v-textarea>
          <v-file-input truncate-length="15" color="#4caf50" label="模型预览图片上传"
            @change="(f) => (form.mod_image_file = fileChange(f))" accept="image/*" show-size></v-file-input>

          <v-file-input truncate-length="15" color="#4caf50" label="模型全景视图上传" v-if="!form.mod_exist"
            @change="(f) => (form.mod_view_file = fileChange(f))" multiple show-size></v-file-input>

          <div class="text-success" v-if="!form.mod_exist">模型全景图片请参考 <a>《设备模型的全景图片》</a></div>

          <v-file-input truncate-length="15" color="#4caf50" label="模型视频资料上传" v-if="!form.mod_exist"
            @change="(f) => (form.mod_video_file = fileChange(f))" accept="video/*" show-size></v-file-input>

          <v-file-input truncate-length="15" color="#4caf50" v-if="form.mod_exist" label="模型上传"
            @change="(f) => (form.mod_file = fileChange1(f))" show-size accept=".FBX,.fbx"></v-file-input>

            <v-file-input truncate-length="15" color="#4caf50" v-if="form.mod_exist_high_precision" label="高精度模型上传"
            @change="(f) => (form.mod_file_high_precision = fileChange1(f))" show-size accept=".FBX,.fbx"></v-file-input>

          <v-file-input v-else truncate-length="15" color="#4caf50" label="模型CAD文件上传"
            @change="(f) => (form.mod_cad_file = fileChange(f))" show-size></v-file-input>

          <div class="text-success" v-if="!form.mod_exist">关于模型的CAD文件标准,请参考 <a>《设备模型的CAD文件标准》</a></div>

          <v-textarea v-model="form.mod_remark" label="申请备注" color="#4caf50"></v-textarea>
          <div style="padding-top: 10px">
            <p class="text-success" v-if="!form.mod_exist">注 : 提交审核后,请在 「开发中心」 「模型申请」 中查看</p>
            <p class="text-success" v-if="form.mod_exist">注 : 提交审核后,请在 「开发中心」 「模型审核」 中查看</p>
          </div>
        </v-card-text>
        <v-card-actions md-alignment="right" style="margin-right: 0">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="submit" :disabled="invalidFile">提交审核</v-btn>
          <v-btn color="success" @click="cancel">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { extend } from 'vee-validate'
import { email, required, required_if } from 'vee-validate/dist/rules'
import { upload, ossUpload } from '@/api/user'
import { addModelResource } from '@/api/model_resource'
import Dropzone from 'dropzone'

extend('required', required)
extend('required_if', required_if)

const initForm = () => ({
  model_resource_category: 'device',
  mod_name: '',
  mod_type: '',
  mod_major: '04',
  mod_industry: '',
  model_category: 'device',
  mod_function: '',
  mod_exist: true,
  mod_exist_high_precision:true,
  mod_description: '',
  mod_image_file: null,
  mod_file: null, // 模型存在时直接上传模型
  mod_file_high_precision: null, // 高精度模型存在时直接上传模型
  mod_cad_file: null, // 模型不存在时上传CAD
  mod_view_file: null, // 模型不存在时上传模型六视图
  mod_video_file: null, // 模型不存在时上传视频资料
  mod_remark: ''
})

export default {
  props: {
    showNewDialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      valid: false,
      uid: '',
      form: initForm(),
      // 专业分类
      majorListData: [],
      // 二级分类
      level2: [],
      // 三级分类
      level3: [],
      uploadProgress: '',
      categoryList: [
        { name: '设备', type: 'device' },
        { name: '角色', type: 'role' },
        { name: '工具', type: 'tool' },
        { name: '场景', type: 'scene' }
      ],
      overlay: false,
    }
  },
  watch: {
    'form.model_category'(val) {
      this.initDict(val);
    }
  },
  mounted() {
    this.initDict('device')
  },
  computed: {
    invalidFile() {
      return !(
        (
          this.form.mod_image_file && // 图像文件必须存在 并且
          (this.form.mod_file || // 模型文件必须存在 或者
          this.form.mod_file_high_precision||(this.form.mod_cad_file && this.form.mod_view_file && this.form.mod_video_file))
        ) // CAD文件、六视图文件、视频资料必须存在
      )
    }
  },
  methods: {
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '1'
        },
        (res) => {
          this.majorListData = res
        }
      )

    },
    fileChange(e) {
      console.log({
        e,
        f: this.form
      })
      return e
    },
    fileChange1(e) {
       const regex = /\(.*\)/;
        if (regex.test(e.name)) {
              this.$notify({
                timeout: 1500,
                message: '模型文件名称不允许包含括号！',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning'
              })
          return false
        } else {
          console.log("字符串不包含括号");
            return e
        }



      // console.log({
      //   e,
      //   f: this.form
      // })
      // return e
    },
    cancel() {
      this.$emit('handleCloseDialog')
    },
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    async submit() {
      this.$refs.form.validate()
      if (this.valid) {
        const form = {
          model_resource_category: this.form.model_resource_category,
          model_name: this.form.mod_name,
          profession: this.form.mod_major,
          one_level_classify: this.form.mod_major,
          industry: this.form.mod_industry,
          model_category: this.form.model_category,
          model_file_type: this.form.mod_filetype,
          function_category: this.form.mod_function,
          is_public: true,
          model_image: null,
          model_file: null,
          model_cad_file: null,
          model_view_file: null,
          model_video_file: null,
          description: this.form.mod_description,
          // status: this.form.mod_exist ? 5 : 1,
          status: 7,
          is_model: this.mod_exist,
          model_remark: this.form.mod_remark
        }

        this.overlay = true;
        this.uploadProgress = '上传图片...'
        form.model_image = await this.uploadFile('modelImage', this.form.mod_image_file)
        if (this.form.mod_exist&&this.form.mod_file) {
          form.ishighPrecision = false;
          this.uploadProgress = '上传模型...'
          form.model_file = await this.uploadFile('modelFile', this.form.mod_file)
        } else if(this.form.mod_exist_high_precision&&this.form.mod_file_high_precision){
            form.ishighPrecision = true;
            this.uploadProgress = '上传高精度模型...'
            form.mod_file_high_precision = await this.uploadFile('modelFile', this.form.mod_file_high_precision)
        }else{
          this.uploadProgress = '上传CAD...'
          form.model_cad_file = await this.uploadFile('modelCADFile', this.form.mod_cad_file)
          this.uploadProgress = '上传模型全景视图...'
          const modelFiles = this.form.mod_view_file
          const fileArr = []
          for (const file of modelFiles) {
            const url = await this.uploadFile('modelViewFile', file)
            fileArr.push(url)
          }
          form.model_view_file = fileArr
          this.uploadProgress = '上传视频资料...'
          form.model_video_file = await this.uploadFile('modelVideoFile', this.form.mod_video_file)
        }
        this.uploadProgress = '上传完成'

        await addModelResource(form)
          .then((res) => {
            if (res.code === '200') {
              this.$notify({
                timeout: 1500,
                message: '操作成功！',
                icon: 'add_alert',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'success'
              })
              this.$emit('handleCloseDialog', res.data)
            } else {
              this.$notify({
                timeout: 1500,
                message: '操作失败',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning'
              })
            }
            this.form = initForm()
          })
          
          .finally((_) => {
            this.uploadProgress = ''
            this.overlay = false;
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0px;
}

::v-deep .v-sheet.v-banner .v-banner__wrapper {
  padding: 0;
}

::v-deep .v-text-field__details {
  overflow: unset;
}
</style>
